<script setup lang="ts">
import type { CondoCardFooterProps } from '.';

import { cn } from '@/utils';
import { CONDO_CARD } from '~~/utils/symbols';
import { Primitive } from 'reka-ui';

import {
	condoCardFooterAddressVariants,
	condoCardFooterNameVariants,
	condoCardFooterTypesVariants
} from '.';

withDefaults(defineProps<CondoCardFooterProps>(), {
	titleAs: 'h4'
});

const condo = inject(CONDO_CARD);

const name = computed<string>(() => condo?.name || '');
const address = computed<string>(() => {
	const address = condo?.address;
	const number = condo?.number;
	const region = condo?.region;
	const city = condo?.city;
	const state = condo?.state;

	return `${address}, ${number} - ${region}, ${city} - ${state}`;
});
</script>

<template>
	<div class="flex flex-col gap-2 p-4">
		<Primitive
			:as="titleAs"
			:class="cn(condoCardFooterNameVariants({ variant, size }))"
		>
			{{ name }}
		</Primitive>

		<p :class="cn(condoCardFooterAddressVariants({ variant, size }))">
			{{ address }}
		</p>
	</div>
</template>
